import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  overflow-y: auto;
  height: 100%;

  ::-webkit-scrollbar {
    background-color: ${props => props.theme.colors.colorf3f5f9};
    width: 16px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${props => props.theme.colors.colorf3f5f9};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.colors.colorbabac0};
    border-radius: 16px;
    border: 4px solid ${props => props.theme.colors.colorf3f5f9};
  }

  ::-webkit-scrollbar-button {
    display: none;
  }
`

export const Spacer = styled.div`
  height: 36px;
`
